import React, { useState } from "react";

interface NestedOptions {
  [groupLabel: string]: {
    [optionValue: string]: string;
  };
}

interface PolicyTypeSelectProps {
  options: NestedOptions;
  value?: string;
  onChange?: (selectedValue: string) => void;
  placeholder?: string;
  name?: string;
  classNameAdditional?: string;
}

const PolicyTypeSelect: React.FC<PolicyTypeSelectProps> = ({
  options,
  value = "",
  onChange,
  placeholder = "Изберете тип на полицата",
  name = "policyType",
  classNameAdditional = "",
}) => {
  const [selectedValue, setSelectedValue] = useState<string>(value);

  React.useEffect(() => {
    setSelectedValue(value);
  }, [value]);

  const handleChange = (event: React.ChangeEvent<HTMLSelectElement>) => {
    const newValue = event.target.value;
    setSelectedValue(newValue);
    if (onChange) onChange(newValue);
  };

  return (
    <div>
      <label className="mb-1 ml-1 block text-xs font-medium text-black dark:text-white">
        Базов тип на полицата
      </label>
      <div className="dark:bg-form-input relative z-20 w-full bg-transparent">
        <select
          value={selectedValue}
          name={name}
          onChange={handleChange}
          className={`border-stroke focus:border-primary active:border-primary dark:border-form-strokedark dark:bg-form-input dark:focus:border-primary relative z-20 w-full appearance-none rounded border bg-transparent px-2 py-1.5 pr-7 text-xs outline-none transition ${
            selectedValue ? "text-black dark:text-white" : "text-gray-500"
          } ${classNameAdditional}`}
        >
          {!selectedValue && (
            <option value="" disabled hidden>
              {placeholder}
            </option>
          )}
          {Object.entries(options || {}).map(
            ([optGroupLabel, optGroupOptions]) => (
              <optgroup key={optGroupLabel} label={optGroupLabel}>
                {Object.entries(optGroupOptions || {}).map(
                  ([optionValue, optionLabel]) => (
                    <option
                      key={optionValue}
                      value={optionValue}
                      className="text-body dark:text-bodydark"
                    >
                      {optionLabel}
                    </option>
                  )
                )}
              </optgroup>
            )
          )}
        </select>
        <span className="absolute top-1/2 right-2.5 z-30 -translate-y-1/2 text-xs">
          <i className="fa-solid fa-chevron-down" />
        </span>
      </div>
    </div>
  );
};

export default PolicyTypeSelect;
